// extracted by mini-css-extract-plugin
module.exports =  {"row":"history-module_row__gfvCecSV5dA0KPZL3rRy","container":"history-module_container__gNaZ99DNRNfPzTmbVA6y"};